import { TaskState, EditorStateOps } from '@src/editor-helpers'
import { EditorState, SelectionState, DraftEditorCommand } from 'draft-js'

export const handleBackspace = (
  editorState: EditorState,
  command: DraftEditorCommand
): EditorState | undefined | void => {
  if (command === 'backspace') {
    const focusBlock = EditorStateOps.getFocusBlock(editorState)
    const blockKey = focusBlock.get('key')
    const blockType = focusBlock.get('type')
    const selection = editorState.getSelection()

    const taskState = TaskState.fromEditorState(editorState)
    const focusTask = TaskState.getTaskByKey(taskState, blockKey)
    const focusTaskIndex = taskState.findIndex(el => el === focusTask)
    let taskBefore
    if (focusTaskIndex !== 0) {
      taskBefore = taskState[focusTaskIndex - 1]
    }

    if (blockType === 'solution' && selection.get('focusOffset') === 0) {
      return editorState
    } else if (
      selection.get('focusOffset') === 0 &&
      blockType === 'unstyled' &&
      TaskState.getFirstBlockInTask(focusTask) === blockKey
    ) {
      if (taskState.length === 1) {
        return editorState
      } else {
        focusTask.solutionKeys.forEach(key => {
          editorState = EditorStateOps.removeBlock(editorState, key)
        })
        focusTask.decisionKeys.forEach(key => {
          editorState = EditorStateOps.removeBlock(editorState, key)
        })
        editorState = EditorStateOps.removeBlock(editorState, focusBlock.get('key'))
        editorState = EditorState.forceSelection(editorState, selection)
        if (taskBefore) {
          const conspectKey = taskBefore.conspectKeys[taskBefore.conspectKeys.length - 1]
          let selection = SelectionState.createEmpty(conspectKey)
          const content = editorState.getCurrentContent()
          const conspectBlock = content.getBlockForKey(conspectKey)
          selection = selection.set('anchorOffset', conspectBlock.getLength()) as SelectionState
          selection = selection.set('focusOffset', conspectBlock.getLength()) as SelectionState
          editorState = EditorState.forceSelection(editorState, selection)
        }
        return editorState
      }
    }
  }
}

export const handleDelete = (editorState: EditorState, command: DraftEditorCommand): EditorState | undefined | void => {
  if (command === 'delete') {
    let selection = editorState.getSelection()
    const blockKey = selection.get('focusKey')
    const content = editorState.getCurrentContent()
    const block = content.getBlockAfter(blockKey)

    if (['solution', 'decision'].includes(block.get('type')) && block.getLength() === 0) {
      return editorState
    }
  } else {
    return undefined
  }
}



// WEBPACK FOOTER //
// ./src/components/RemarksApplicationRoot/handleDeletes.ts